import './TotalNotification.scss'

const TotalNotification = (props: {
  multiple?: boolean
  detailTitle: string
  totalNotificationCount: number | undefined
  icon: any
}) => {
  const displayCount = props.totalNotificationCount ?? 0
  
  return (
    <>
      <div className="total-notify-container">
        <div className="total-notify">
          {props.icon}
          <p style={{ fontSize: props?.multiple ? '24px' : '30px' }}>{displayCount}</p>
        </div>
      </div>
      <div className="detail-title">
        <p style={{ maxWidth: props.multiple ? '110px' : '230px', textAlign: 'left' }}>{props.detailTitle}</p>
      </div>
    </>
  )
}

export default TotalNotification
